import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { formatPrice } from "@/lib/api";

const Group = ({ title, children }) => (
  <div className="py-6 border-b border-[#D5B98C]/40">
    <h4 className="text-[11px] uppercase tracking-[0.22em] text-[#956842] mb-4">{title}</h4>
    {children}
  </div>
);

const CheckList = ({ name, options, selected, onToggle }) => (
  <div className="space-y-2.5">
    {options.map((o) => (
      <label key={o} className="flex items-center gap-3 text-sm cursor-pointer">
        <Checkbox data-testid={`filter-${name}-${o.toLowerCase().replace(/\s+/g, "-")}`} checked={selected.includes(o)} onCheckedChange={() => onToggle(name, o)} className="border-[#956842] data-[state=checked]:bg-[#39251D]" />
        {o}
      </label>
    ))}
  </div>
);

const PriceFilter = ({ facets, value, onCommit }) => {
  const [local, setLocal] = useState(value);
  useEffect(() => { setLocal(value); }, [value[0], value[1]]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Group title="Prezzo">
      <Slider data-testid="filter-price-slider" min={facets.min_price} max={facets.max_price} step={1} value={local} onValueChange={setLocal} onValueCommit={onCommit} className="mt-2" />
      <div className="flex justify-between text-xs mt-3 text-[#242321]/70">
        <span data-testid="filter-price-min">{formatPrice(local[0])}</span>
        <span data-testid="filter-price-max">{formatPrice(local[1])}</span>
      </div>
    </Group>
  );
};

export const Filters = ({ cats, activeCat, facets, state, onToggle, onPrice, onAvailable, onReset }) => (
  <div data-testid="catalog-filters">
    <Group title="Categoria">
      <ul className="space-y-2 text-sm">
        <li><Link to="/collezione" data-testid="filter-category-all" className={!activeCat ? "text-[#956842] font-semibold" : "hover:text-[#956842]"}>Tutte</Link></li>
        {cats.map((c) => (
          <li key={c.slug}>
            <Link to={`/categoria/${c.slug}`} data-testid={`filter-category-${c.slug}`} className={activeCat === c.slug ? "text-[#956842] font-semibold" : "hover:text-[#956842]"}>{c.name}</Link>
          </li>
        ))}
      </ul>
    </Group>
    {facets && <PriceFilter facets={facets} value={state.price} onCommit={onPrice} />}
    {facets && <Group title="Colore"><CheckList name="color" options={facets.colors} selected={state.color} onToggle={onToggle} /></Group>}
    {facets && <Group title="Materiale"><CheckList name="material" options={facets.materials} selected={state.material} onToggle={onToggle} /></Group>}
    <Group title="Disponibilità">
      <label className="flex items-center justify-between text-sm cursor-pointer">
        Solo disponibili
        <Switch data-testid="filter-available-switch" checked={state.available} onCheckedChange={onAvailable} />
      </label>
    </Group>
    <button data-testid="filter-reset-button" onClick={onReset} className="mt-6 text-xs uppercase tracking-[0.2em] border-b border-[#956842] pb-1">Azzera filtri</button>
  </div>
);
